import React from 'react';

import { IContributor } from '~/interfaces/components/Contributor';

type IContributorsProps = {
  contributors: IContributor[];
  text: string | undefined;
};

const Contributors: React.FC<IContributorsProps> = ({ contributors, text }) => {
  return (
    <div className="author__contributors">
      <span className="author__contributors-text">{text}</span>
      <ul className="author__contributors-list">
        {contributors.map((contributor) => (
          <li className="author__contributor-item" key={`author__contributor-${contributor.name}`}>
            <span className="author__contributor-name">
              {contributor.link?.href ? (
                <a href={contributor.link.href} className="author__name_link" rel="author">
                  {contributor.name}
                </a>
              ) : (
                contributor.name
              )}
            </span>
            {contributor.role}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Contributors;
